import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function DrinkMenuPage() {
  const [drinkData, setDrinkData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedDrink, setSelectedDrink] = useState(0);
  const [updatedStatus, setUpdatedStatus] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [newDrinkSubmitted, setNewDrinkSubmitted] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [drinkDetails, setDrinkDetails] = useState({
    name: "",
    description: "",
    price: 0,
    imageUrl: "",
    isActive: true,
    drinkCategoryId: "",
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterDrinks, setFilterDrinks] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const totalDrinks = filteredData.length;
  const computedDrinks = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Check file size (2MB = 2 * 1024 * 1024 bytes)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        alert("Kích thước hình ảnh không được vượt quá 2MB. Vui lòng chọn hình ảnh khác.");
        e.target.value = ""; // Clear the file input
        return;
      }
      
      setImageFile(file);

      // Show loading state
      setDrinkDetails({
        ...drinkDetails,
        imageUrl: "uploading...",
      });

      // Upload image immediately and set imageUrl to returned filename
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("description", drinkDetails.name || "drink image");
      formData.append("clientDate", new Date().toISOString());

      try {
        const res = await axios.post(
          `${config.apiEndpoint}/Drink/upload`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );
        // Set the returned filename to imageUrl
        setDrinkDetails({
          ...drinkDetails,
          imageUrl: res.data.imageUrl, // API returns the filename string
        });
        console.log("Image uploaded successfully:", res.data.imageUrl);
      } catch (err) {
        console.error("Image upload failed:", err);
        setDrinkDetails({
          ...drinkDetails,
          imageUrl: "",
        });
        setImageFile(null);
        alert("Image upload failed. Please try again.");
      }
    }
  };

  const addNewDrink = () => {
    const token = localStorage.getItem('token');
    console.log('drinkDetails', drinkDetails);
    axios
      .post(
        `${config.apiEndpoint}/Drink`,
        {
          name: drinkDetails.name,
          description: drinkDetails.description,
          price: drinkDetails.price,
          imageUrl: drinkDetails.imageUrl,
          isActive: drinkDetails.isActive,
          drinkCategoryId: drinkDetails.drinkCategoryId,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setDrinkDetails({
            name: "",
            description: "",
            price: 0,
            imageUrl: "",
            isActive: true,
            drinkCategoryId: "",
          });
          setImageFile(null);
          console.log("New drink added successfully");
          setButtonNewPopup(false);
          setNewDrinkSubmitted(!newDrinkSubmitted);
        }
      })
      .catch((err) => {
        console.error("Error adding new drink:", err);
      });
  };

  const updateDrink = () => {
    const token = localStorage.getItem('token');
    const drink = drinkData[selectedDrink];
    
    // Use new uploaded image if available, otherwise keep existing image
    const finalImageUrl = imageFile && drinkDetails.imageUrl ? drinkDetails.imageUrl : drink.imageUrl;
    
    axios
      .put(
        `${config.apiEndpoint}/Drink/${drink.id}`,
        {
          id: drink.id,
          name: drinkDetails.name,
          description: drinkDetails.description,
          price: drinkDetails.price,
          imageUrl: finalImageUrl,
          isActive: updatedStatus,
          drinkCategoryId: drinkDetails.drinkCategoryId,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          console.log("Drink updated successfully");
          setButtonShowPopup(false);
          setDrinkDetails({
            name: "",
            description: "",
            price: 0,
            imageUrl: "",
            isActive: true,
            drinkCategoryId: "",
          });
          setImageFile(null);
          setNewDrinkSubmitted(!newDrinkSubmitted);
        }
      })
      .catch((err) => {
        console.error("Error updating drink:", err);
      });
  };

  const deleteDrink = (drinkId) => {
    const token = localStorage.getItem('token');
    axios
      .delete(`${config.apiEndpoint}/Drink/${drinkId}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          setNewDrinkSubmitted(!newDrinkSubmitted);
          console.log("Drink removed successfully");
        }
      })
      .catch((err) => {
        console.error("Error removing drink:", err);
      });
  };

  // Fetch categories for dropdown
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/DrinkCategory`, { 
      headers: { Authorization: `Bearer ${token}` }, 
      withCredentials: true 
    })
      .then(res => {
        console.log('categoryData', res.data);
        setCategoryData(res.data.filter(cat => cat.isActive)); // Only active categories
      })
      .catch((err) => {
        console.error("Error fetching drink categories:", err);
      });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/Drink`, { 
      headers: { Authorization: `Bearer ${token}` }, 
      withCredentials: true 
    })
      .then(res => {
        console.log('drinkData', res.data);
        setDrinkData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching drinks:", err);
      });
  }, [newDrinkSubmitted]);

  // Auto filter when filterActive or drinkData changes
  useEffect(() => {
    if (filterActive === 1) {
      setFilteredData(drinkData);
    } else if (filterActive === 2) {
      setFilteredData(drinkData.filter(drink => drink.isActive));
    } else if (filterActive === 3) {
      setFilteredData(drinkData.filter(drink => !drink.isActive));
    }
  }, [drinkData, filterActive]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Drink Menu</h1>
          <Pagination
            total={totalDrinks}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterDrinks("");
                    setFilterActive(1);
                  }}
                >
                  All drinks
                </li>
                <li
                  className={`${filterActive === 2 ? "active" : ""}`}
                  onClick={() => {
                    setFilterDrinks("active");
                    setFilterActive(2);
                  }}
                >
                  Active
                </li>
                <li
                  className={`${filterActive === 3 ? "active" : ""}`}
                  onClick={() => {
                    setFilterDrinks("inactive");
                    setFilterActive(3);
                  }}
                >
                  Inactive
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={drinkData}
                handleSearchChange={handleSearchChange}
                dataType="drink"
                status={filterDrinks}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Price</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedDrinks.map((drink) => {
                  return (
                    <tr key={drink.id}>
                      <td>
                        <font className="maincolor">#</font>
                        {drink.id}
                      </td>
                      <td>
                        {drink.imageUrl && (
                          <img
                            src={config.uploadEndpoint+"/" + drink.imageUrl}
                            alt={drink.name}
                            style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                          />
                        )}
                      </td>
                      <td>{drink.name}</td>
                      <td>{drink.description}</td>
                      <td>{drink.price} vnđ</td>
                      <td>{drink.drinkCategoryName}</td>
                      <td>
                        <span className={`status ${drink.isActive ? 'active' : 'inactive'}`}>
                          {drink.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>{new Date(drink.createdAt).toLocaleDateString()}</td>
                      <td className="maincolor">
                        <button
                          className=""
                          style={{ marginRight: "20px" }}
                          onClick={() => deleteDrink(drink.id)}
                        >
                          <RemoveRoundedIcon />
                        </button>
                        <button
                          className=""
                          onClick={() => {
                            setButtonShowPopup(true);
                            setSelectedDrink(drinkData.indexOf(drink));
                            setUpdatedStatus(drink.isActive);
                            setImageFile(null); // Reset image file
                            setDrinkDetails({
                              name: drink.name,
                              description: drink.description,
                              price: drink.price,
                              imageUrl: drink.imageUrl,
                              isActive: drink.isActive,
                              drinkCategoryId: drink.drinkCategoryId,
                            });
                          }}
                        >
                          <ReadMoreRoundedIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add New Drink Popup */}
      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap" style={{ height: "750px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new drink</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails" style={{ height: "80%" }}>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Drink name"
                    className="orderDetailsInput"
                    value={drinkDetails.name}
                    onChange={(e) =>
                      setDrinkDetails({
                        ...drinkDetails,
                        name: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <textarea
                    placeholder="Description"
                    className="orderDetailsInput"
                    value={drinkDetails.description}
                    onChange={(e) =>
                      setDrinkDetails({
                        ...drinkDetails,
                        description: e.target.value,
                      })
                    }
                    rows="4"
                    style={{ minHeight: "100px", resize: "vertical" }}
                  />
                </div>
                <div className="input-group">
                  <input
                    type="number"
                    placeholder="Price"
                    className="orderDetailsInput"
                    value={drinkDetails.price}
                    onChange={(e) =>
                      setDrinkDetails({
                        ...drinkDetails,
                        price: Number(e.target.value),
                      })
                    }
                    min="0"
                    step="0.01"
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <select
                    className="orderDetailsInput"
                    value={drinkDetails.drinkCategoryId}
                    onChange={(e) =>
                      setDrinkDetails({
                        ...drinkDetails,
                        drinkCategoryId: e.target.value,
                      })
                    }
                    required="required"
                  >
                    <option value="">Select Category</option>
                    {categoryData.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="input-group">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    className="orderDetailsInput"
                    onChange={handleImageChange}
                  />
                  {drinkDetails.imageUrl && (
                    <div style={{ marginTop: 10 }}>
                      <p style={{ fontSize: "12px", color: "#007bff", marginBottom: "5px" }}>
                        {drinkDetails.imageUrl === "uploading..." ? "Uploading..." : "Uploaded image:"}
                      </p>
                      {drinkDetails.imageUrl === "uploading..." ? (
                        <div style={{ padding: "20px", textAlign: "center", color: "#007bff" }}>
                          <div>📤 Uploading image...</div>
                        </div>
                      ) : (
                        <img
                          src={config.uploadEndpoint + "/" + drinkDetails.imageUrl}
                          alt="Uploaded preview"
                          style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "4px", border: "2px solid #28a745" }}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div
                className="productSummaryRight newUserSwitch"
                style={{ width: "100%" }}
              >
                <h3>Is Active </h3>
                <input
                  type="radio"
                  name="addRdo"
                  id="addYes"
                  checked={drinkDetails.isActive}
                  onChange={() => setDrinkDetails({ ...drinkDetails, isActive: true })}
                />
                <input
                  type="radio"
                  name="addRdo"
                  id="addNo"
                  checked={!drinkDetails.isActive}
                  onChange={() => setDrinkDetails({ ...drinkDetails, isActive: false })}
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="addYes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="addNo">
                    No
                  </label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewDrink()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      {/* Edit Drink Popup */}
      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
        <div className="popupWrap" style={{ height: "700px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit drink</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderPageSection" style={{ height: "auto" }}>
                {/* Left Side - Image */}
                <div className="orderPageLeftSide" style={{ width: "40%" }}>
                  <div className="input-group">
                    {drinkData[selectedDrink] && drinkData[selectedDrink].imageUrl && (
                      <img
                        src={config.uploadEndpoint + "/" + drinkData[selectedDrink].imageUrl}
                        alt={drinkData[selectedDrink].name}
                        style={{ width: "100%", maxWidth: "300px", height: "auto", borderRadius: "4px" }}
                      />
                    )}
                  </div>
                  <div className="input-group">
                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      className="orderDetailsInput"
                      onChange={handleImageChange}
                    />
                    {imageFile && (
                      <span style={{ marginTop: 10, fontSize: "12px", color: "#666" }}>
                        New image selected: {imageFile.name}
                      </span>
                    )}
                    {drinkDetails.imageUrl && imageFile && (
                      <div style={{ marginTop: 10 }}>
                        <p style={{ fontSize: "12px", color: "#007bff", marginBottom: "5px" }}>
                          {drinkDetails.imageUrl === "uploading..." ? "Uploading new image..." : "New uploaded image:"}
                        </p>
                        {drinkDetails.imageUrl === "uploading..." ? (
                          <div style={{ padding: "20px", textAlign: "center", color: "#007bff" }}>
                            <div>📤 Uploading new image...</div>
                          </div>
                        ) : (
                          <img
                            src={config.uploadEndpoint + "/" + drinkDetails.imageUrl}
                            alt="New uploaded"
                            style={{ width: "100%", maxWidth: "200px", height: "auto", borderRadius: "4px", border: "2px solid #007bff" }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Side - Form Fields */}
                <div className="orderPageRightSide" style={{ width: "60%" }}>
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="Drink name"
                      className="orderDetailsInput"
                      value={drinkDetails.name}
                      onChange={(e) =>
                        setDrinkDetails({
                          ...drinkDetails,
                          name: e.target.value,
                        })
                      }
                      required="required"
                    />
                  </div>
                  <div className="input-group">
                    <textarea
                      placeholder="Description"
                      className="orderDetailsInput"
                      value={drinkDetails.description}
                      onChange={(e) =>
                        setDrinkDetails({
                          ...drinkDetails,
                          description: e.target.value,
                        })
                      }
                      rows="4"
                      style={{ minHeight: "100px", resize: "vertical" }}
                    />
                  </div>
                  <div className="input-group">
                    <input
                      type="number"
                      placeholder="Price"
                      className="orderDetailsInput"
                      value={drinkDetails.price}
                      onChange={(e) =>
                        setDrinkDetails({
                          ...drinkDetails,
                          price: Number(e.target.value),
                        })
                      }
                      min="0"
                      step="0.01"
                      required="required"
                    />
                  </div>
                  <div className="input-group">
                    <select
                      className="orderDetailsInput"
                      value={drinkDetails.drinkCategoryId}
                      onChange={(e) =>
                        setDrinkDetails({
                          ...drinkDetails,
                          drinkCategoryId: e.target.value,
                        })
                      }
                      required="required"
                    >
                      <option value="">Select Category</option>
                      {categoryData.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="productSummaryRight newUserSwitch"
                style={{ width: "100%", marginTop: "20px" }}
              >
                <h3>Is Active </h3>
                <input
                  type="radio"
                  name="editRdo"
                  id="editYes"
                  checked={updatedStatus}
                  onChange={() => setUpdatedStatus(true)}
                />
                <input
                  type="radio"
                  name="editRdo"
                  id="editNo"
                  checked={!updatedStatus}
                  onChange={() => setUpdatedStatus(false)}
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="editYes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="editNo">
                    No
                  </label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => updateDrink()}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default DrinkMenuPage;